import LeaveRequestService from '../../../../../services/leave-request'
import adminLeaveRequestApprovalPopupStore from '../../../../../store/adminLeaveRequestApprovalPopupStore'
import authStore from '../../../../../store/authStore'
import { ApprovalPopupProps } from './props'

export default function useApprovalPopupViewModel(props: ApprovalPopupProps) {
  const user = authStore(state => state.user)
  const open = adminLeaveRequestApprovalPopupStore(state => state.open)
  const approvalStatus = adminLeaveRequestApprovalPopupStore(state => state.approvalStatus)
  const data = adminLeaveRequestApprovalPopupStore(state => state.data)
  const isLoading = adminLeaveRequestApprovalPopupStore(state => state.isLoading)

  function onClose() {
    if (!!props.onClose) props.onClose()
    adminLeaveRequestApprovalPopupStore.setState({
      approvalStatus: null,
      data: null,
      open: false,
      isLoading: false,
      isError: false,
      isSuccess: false,
    })
  }

  async function onConfirm() {
    if (!!data && !!approvalStatus) {
      adminLeaveRequestApprovalPopupStore.setState({ isLoading: false, isError: false, isSuccess: false })
      await LeaveRequestService.setApprovalById({
        id: data.id,
        approvalBy: user?.displayName ?? user?.email ?? user?.uid ?? null,
        approvalStatus: approvalStatus,
      })
        .then(() => {
          adminLeaveRequestApprovalPopupStore.setState({ isLoading: false, isSuccess: true })
        })
        .catch(error => {
          console.log(error)
          adminLeaveRequestApprovalPopupStore.setState({ isLoading: false, isError: true })
        })
        .finally(() => {
          if (!!props.onConfirm) props.onConfirm()
          onClose()
        })
    }
  }

  return {
    open,
    approvalStatus,
    data,
    onClose,
    onConfirm,
    isLoading,
  }
}
